// removed by extract-text-webpack-plugin
module.exports = {"content":"_3Om1nDP9Lfz7W1TsQ72p0Q","orderTitle":"_2vmpWD2bZD4YPMi1iBN-bd"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Settings/settings.scss
// module id = 1264
// module chunks = 0